import axios from 'axios';

const requestProject = async (
  values,
  activity_id,
  language,
  package_id,
  num_pos,
  total,
  discount_cost,
  code_id,
  sollemKey,
  Active
) => {
  try {
    const formData = new FormData();
    formData.append('name', values.first_name);
    formData.append('activity', values.activity);
    formData.append('phone', values.phone_number);
    // formData.append('email', values.address);
    formData.append('package_id', package_id);
    formData.append('discount_cost', discount_cost);
    formData.append('code_id', code_id);
    formData.append('subscriptionType', activity_id);
    formData.append('commercialRecord', values.commercialRecord);
    formData.append('sollemKey', sollemKey);
    // formData.append('password', values.password);
    if (Active !== 0) {
      formData.append('payment_type', Active);
    }
    if (package_id === 1) {
      formData.append('num_pos', 2);
      // console.log('inside');
    } else {
      formData.append('num_pos', num_pos);
    }
    formData.append('tax_number', values.tax_number);

    formData.append('total', total);
    console.log('total: ', total);
    console.log('formData: ', formData);

    const response = await axios.post('/register', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        lang: language
      }
    });
    // console.log(response.data);

    // if (response.status === 200 && response.data.status === 1 && response.data.data) {
    return response.data;
    // }
  } catch (e) {}
};

export default requestProject;
